import * as THREE from 'three';

import ShootGeometry from "./ShootGeometry";
import ShootMaterial from './ShootMaterial';

class Stem extends THREE.Group {

    path;
    geometry;
    material;
    mesh;

    growing: boolean = false;
    growStart: number;
    growEnd: number;
    growCallback: Function;

    constructor(shootPreset: ShootPreset) {
        super();

        this.geometry = new ShootGeometry(shootPreset)
        this.material = new ShootMaterial(shootPreset.materialPreset);
        this.mesh = new THREE.Mesh(this.geometry, this.material);

        this.add(this.mesh);
    }

    grow(duration, callback) {
        this.growing = true;
        this.growStart = Date.now();
        this.growEnd = this.growStart + duration;
        this.growCallback = callback;
    }

    update(time) {
        if (this.growing) {
            let t = (Date.now() - this.growStart) / (this.growEnd - this.growStart);

            this.material.uniforms.progress.value = t;

            if (t >= 1) {
                this.growing = false;
                if (this.growCallback != null) this.growCallback();
            }
        }
    }

}

export default Stem;